// Auto-generated from table.spec.js
export default {
  "tagName": "ui-table"
};
